import { render, staticRenderFns } from "./MDataDatesComp.vue?vue&type=template&id=08023f7c&"
import script from "./MDataDatesComp.vue?vue&type=script&lang=js&"
export * from "./MDataDatesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports